import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  list: [],
};

const EventUsersListSlice = createSlice({
  name: "EventUsersList",
  initialState,
  reducers: {
    eventUsersListSuccess(state, action) {
      state.list = action.payload
    }
  },
});

export const {
  eventUsersListSuccess
} = EventUsersListSlice.actions

export default EventUsersListSlice.reducer;
